export const WindowsLogo: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={18}
    fill="none"
    {...props}
  >
    <title>Windows Logo</title>
    <g clipPath="url(#a)">
      <path
        fill="#F7F7F7"
        d="M2.393 9V5.062l4.5-.99v4.86L2.393 9Zm12.75-6.75v6.563l-7.5.112V3.907l7.5-1.657Zm-12.75 7.5 4.5.068v5.107l-4.5-.863V9.75Zm12.75.188V16.5l-7.5-1.432V9.825l7.5.113Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.143 0h18v18h-18z" />
      </clipPath>
    </defs>
  </svg>
);
